import React, { useEffect, useState } from "react";
import {
  addCatalogueEntry,
  deleteCatalogueEntry,
  getCatalogue,
  updateCatalogueEntry,
} from "../../api/common/catalogues.ts";
import LGCrud from "../LGCrud";
import { useSnack } from "../../services/SnakbarProvider";
import { handleError } from "../../services/errorHandler";

export default function CrudCatalogue({ catalogueName, codeHeader = "Clave", nameHeader = "Nombre" }) {
  const [list, setList] = useState([]);
  const { openSnack } = useSnack();

  // const fetchData = async () => {
  //   const res = await getCatalogue(catalogueName);
  //   setList(res.data);
  // };

  const handlePost = async (data) => {
    try {
      const payload = {
        ...data,
        CatalogueName: catalogueName,
      };
      const res = await addCatalogueEntry(payload);
      if (res.status === 200 || res.status === 201) {
        openSnack("Entrada agregada con éxito", "success");
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    }
  };

  const handleUpdate = async (id, data) => {
    try {
      const payload = {
        ...data,
        CatalogueName: catalogueName,
      };
      const res = await updateCatalogueEntry(id, payload);
      if (res.status === 200 || res.status === 204) {
        openSnack("Entrada actualizada con éxito", "success");
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    }
  };

  const handleDelete = async (id) => {
    try {
      const res = await deleteCatalogueEntry(id);
      if (res.status === 200 || res.status === 204) {
        openSnack("Entrada eliminada con éxito", "success");
      }
    } catch (error) {
      openSnack(handleError(error), "error");
    }
  };
  // useEffect(() => {
  //   fetchData();
  // }, []);
  return (
    <LGCrud
      data={list}
      columns={[
        {
          field: "code",
          headerName: codeHeader,
          flex: 0.3,
          editable: true,
        },
        {
          field: "name",
          headerName: nameHeader,
          flex: 0.7,
          editable: true,
        },

      ]}
      actionHandlers={{
        create: handlePost,
        update: handleUpdate,
        delete: handleDelete,
        fetchData: getCatalogue
      }}
      catalogueName={catalogueName}
    />
  );
}
